<script>
    import { section } from "../store/section.js";
    import { token } from "../store/token.js";
    import HeadingContent from "./component/HeadingContent.svelte";

    let input_workspace_name;
    let input_workspace_description;

    const set_section = (selected_section) => {
        section.set(selected_section);
    };

    const create_workspace = () => {
        console.log(input_workspace_name);
        console.log(input_workspace_description);

        fetch(`${process.env.API_ROOT}/workspace`, {
            method: "POST",
            mode: "cors",
            headers: {
                Authorization: "Bearer " + $token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                workspace_title: input_workspace_name,
                workspace_description: input_workspace_description,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                console.log(data);

                set_section("account/workspaces");
            })
            .catch(console.log);
    };
</script>

<div class="settings-holder settings-active">
    <!-- Settings Connections Overview (First Level) (the items of the menu of Security)-->
    <div class="settings-holder-content content-active">
        <HeadingContent
            title="Workspaces"
            back_button_enabled={true}
            back_button_click_action={() => {
                set_section("account/workspaces");
            }}
        />
        <!--
        <div class="settings-heading">
            <div
                class="heading-block"
                on:click={() => {
                    set_section("account/workspaces");
                }}
            >
                <a class="nav-opener" href="#"
                    ><i class="icon icon-navigation" /></a
                ><a class="nav-back" href="#">
                    <div class="ico-holder">
                        <i class="icon icon-chevron-left" />
                    </div>
                    <div class="title-holder">
                        <strong class="settings-title">Workspaces</strong>
                    </div></a
                >
            </div>
        </div>
        -->
        <div class="settings-content">
            <div class="settings-content-holder">
                <ul class="list-plans list-unstyled">
                    <div
                        class="header-block"
                        style="margin-top:20px;padding-bottom:0px"
                    >
                        <div class="container">
                            <h1>Create new workspace</h1>
                        </div>
                    </div>
                </ul>
            </div>
        </div>
        <div class="settings-content">
            <div class="settings-content-holder">
                <div class="card-personal card">
                    <div class="card-body">
                        <div class="card-form-block">
                            <div class="form-group">
                                <input
                                    bind:value={input_workspace_name}
                                    type="text"
                                    placeholder="Workspace Title"
                                    data-required="true"
                                />
                            </div>
                            <div class="form-group">
                                <input
                                    bind:value={input_workspace_description}
                                    type="text"
                                    placeholder="Workspace Description"
                                    data-required="true"
                                />
                            </div>
                            <div class="button-holder text-md-right">
                                <a
                                    class="btn btn-primary"
                                    href="#"
                                    on:click={() => {
                                        create_workspace();
                                    }}>Create new workspace</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
